import Alert from '@risk-smart/themed-cloudscape-components/alert';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shown in place of a matrix-cell widget that cannot plot the organisation's
 * fractional scores. Two kinds reach it — the heatmap families through
 * `withRoundedScoresRequired`, and the universal widget's placemat chart type
 * — so the copy names the one the reader is looking at rather than calling a
 * placemat a heatmap. Explanation only: the bubble chart it would point to
 * does not exist yet, so there is no swap action (RSP-7281).
 */
export const ContinuousScoringNotice: FC<{
  widget: 'heatmap' | 'placemat';
}> = ({ widget }) => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'dashboard.continuousScoring',
  });
  const widgetNoun = t(widget === 'placemat' ? 'placematNoun' : 'heatmapNoun');

  return (
    <Alert
      type={'info'}
      header={t('placedMatrixWidgetTitle', { widget: widgetNoun })}
      data-testid={'continuous-scoring-notice'}
    >
      {t('placedMatrixWidgetBody', { widget: widgetNoun })}
    </Alert>
  );
};
